import { skipTracingStore } from "../store";
import { useSnapshot } from "valtio";

export const useBatchName = () => {
  const { batchName } = useSnapshot(skipTracingStore);

  return batchName;
};
